<template>
  <div class="orderDetail">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.orderDetail.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.orderDetail.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>
    <van-tabs
      v-model="state"
      @change="stateChanged"
      title-active-color="#ffffff"
      title-inactive-color="#666666"
      color="#1a347b"
      swipeable
      sticky
      :offset-top="49"
      :ellipsis="false"
      type="card"
    >
      <van-tab
        v-for="(menu, index) in stateList"
        :key="index"
        :title="menu.title + (menu.count > 0 ? ' ' + menu.count : '')"
        :name="menu.name"
      >
        <van-list
          class="list"
          v-model="loading"
          :finished="finished"
          :finished-text="$t.meta.noMore"
          :error.sync="error"
          :error-text="errorText"
          @load="firstLoad(page + 1)"
        >
          <div class="order" v-for="(order, index) in tableData" :key="index">
            <template v-if="state == 0 || state == 1">
              <div class="expressNo">
                {{ $t.orderDetail.expressNumber }}
                <span class="value">{{ order.ExpressNumber }}</span>
              </div>
              <div class="state1" v-if="order.IsCompleteOrderGoodsValue">
                <span class="orange">{{ $t.orderDetail.completeOrderGoodsValue }}</span>
              </div>
              <div class="left1">
                <div class="left1-item" v-if="order.CargoTrackingNumber">
                  {{ $t.orderDetail.cargoTrackingNumber }}
                  <span class="value">{{ order.CargoTrackingNumber }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.cargoName }}&nbsp;&nbsp;
                  <span class="value">{{ order.CargoName }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.cargoQuantity }}&nbsp;&nbsp;
                  <span class="value"
                    >{{ order.CargoQuantity }} {{ order.QuantityUnit }}</span
                  >
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.countryName }}&nbsp;&nbsp;
                  <span class="value">{{ order.CountryName }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.cargoCategory }}&nbsp;&nbsp;
                  <span class="value">{{ order.CargoCategory }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.goodsValue }}&nbsp;&nbsp;
                  <span class="value">{{ order.GoodsValue }} {{ order.Currency }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.taxFeebearingParty }}&nbsp;&nbsp;
                  <span class="value" v-if="order.TaxFeebearingParty == 1">{{
                    $t.orderDetail.shipper
                  }}</span>
                  <span class="value" v-if="order.TaxFeebearingParty == 2">{{
                    $t.orderDetail.consignee
                  }}</span>
                </div>
                <div class="left1-item">
                  {{ $t.orderDetail.isUnpack }}&nbsp;&nbsp;
                  <span class="value" v-if="order.IsUnpack"
                    ><van-icon name="success"
                  /></span>
                  <span class="value" v-else><van-icon name="cross" /></span>
                </div>
              </div>
              <div class="right1" v-if="order.ProductPictureList.length > 0">
                <div class="images">
                  <van-image
                    width="80px"
                    height="80px"
                    fit="cover"
                    :src="imgUrlFilter(order.ProductPictureList[0])"
                    @click="imagePreview(order.ProductPictureList)"
                  />
                </div>
              </div>
              <div class="packages" v-if="state != '0'">
                <div class="packages-item">
                  <span class="packages-item-label">{{
                    $t.orderDetail.inboundBoxNumber
                  }}</span>
                  <span class="packages-item-value">{{ order.NumberPackages }}</span>
                </div>
                <div class="packages-item">
                  <span class="packages-item-label">
                    {{ $t.orderDetail.volume }}
                  </span>
                  <span class="packages-item-value">{{ order.Volume }} cbm </span>
                </div>
                <div class="packages-item">
                  <span class="packages-item-label">{{ $t.orderDetail.weight }}</span>
                  <span class="packages-item-value">{{ order.Weight }} KG </span>
                </div>
              </div>
              <div class="buttons" v-if="state == 0">
                <van-button
                  class="primary-btn"
                  size="small"
                  type="primary"
                  @click="gotoDetail(order)"
                  >{{ $t.orderDetail.editOrder }}</van-button
                >
                <van-button
                  class="danger-btn"
                  size="small"
                  type="danger"
                  @click="onDelete(order.COId)"
                  >{{ $t.orderDetail.deleteOrder }}</van-button
                >
              </div>
            </template>
            <template
              v-if="state == 2 || state == 3 || state == 4 || state == 5 || state == 6"
            >
              <van-collapse v-model="activeNames">
                <van-collapse-item :name="index">
                  <template #title>
                    <div class="header">
                      <div class="wbNumber" v-if="order.WB_Number">
                        {{ $t.orderDetail.wbNumber }}
                        <span class="value">{{ order.WB_Number }}</span>
                      </div>
                      <div class="state2">
                        <span class="red" v-if="order.BillState == 1">{{
                          $t.orderDetail.billState1
                        }}</span>
                        <span class="blue" v-if="order.BillState == 2">{{
                          $t.orderDetail.billState2
                        }}</span>
                        <span class="green" v-if="order.BillState == 3">{{
                          $t.orderDetail.billState3
                        }}</span>
                      </div>
                      <div class="all-packages">
                        <div class="all-packages-item">
                          <van-image width="15" height="15" :src="volumeIcon"></van-image>
                          <span class="all-packages-label">
                            {{ $t.orderDetail.volume }}
                          </span>
                          <span class="all-packages-value">
                            {{ order.AllVolume }} cbm
                          </span>
                        </div>
                        <div class="all-packages-item">
                          <van-image width="15" height="15" :src="weightIcon"></van-image>
                          <span class="all-packages-label">
                            {{ $t.orderDetail.weight }}
                          </span>
                          <span class="all-packages-value">
                            {{ order.AllWeight }} KG
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="buttons">
                      <van-button
                        class="primary-btn"
                        size="small"
                        type="primary"
                        @click="gotoCargoInquiry($event, order.WB_Number)"
                        >{{ $t.orderDetail.viewLogistics }}</van-button
                      >
                      <van-button
                        class="default-btn"
                        size="small"
                        type="primary"
                        @click="gotoPayBillList($event, order.WB_Number)"
                      >
                        <span v-if="order.BillState == 1">{{
                          $t.orderDetail.payBillList
                        }}</span>
                        <span v-else>{{ $t.orderDetail.viewBillList }}</span>
                      </van-button>
                      <van-button
                        class="primary-btn"
                        size="small"
                        type="primary"
                        @click="onShowShipping($event, order.WB_Id)"
                        v-if="state == 3 && order.TakeDeliveryType == 0"
                        >{{ $t.orderDetail.viewShipping }}</van-button
                      >
                      <van-button
                        class="danger-btn"
                        size="small"
                        type="primary"
                        @click="gotoException($event, order.WB_Id)"
                        v-if="state == 4 && order.IsOrderDeliveryException == 1"
                        >{{ $t.orderDetail.viewException }}</van-button
                      >
                    </div>
                  </template>
                  <div class="content">
                    <div
                      class="product"
                      v-for="(product, index) in order.CustomerOrderList"
                      :key="index"
                    >
                      <div class="left2">
                        <div class="left2-item" v-if="product.ExpressNumber">
                          <span class="label">{{ $t.orderDetail.expressNumber }}</span>
                          <span class="value">
                            {{ product.ExpressNumber }}
                          </span>
                        </div>
                        <div class="left2-item" v-if="product.CargoTrackingNumber">
                          <span class="label">{{
                            $t.orderDetail.cargoTrackingNumber
                          }}</span>
                          <span class="value">{{ product.CargoTrackingNumber }}</span>
                        </div>
                        <div class="left2-item" v-if="product.CargoName">
                          <span class="label">
                            {{ $t.orderDetail.cargoName }}
                          </span>
                          <span class="value">
                            {{ product.CargoName }}
                          </span>
                        </div>
                        <div class="left2-item">
                          <span class="label">
                            {{ $t.orderDetail.cargoQuantity }}
                          </span>
                          <span class="value">
                            {{ product.CargoQuantity }} {{ product.QuantityUnit }}
                          </span>
                        </div>
                        <div class="left2-item">
                          <span class="label">
                            {{ $t.orderDetail.goodsValue }}
                          </span>
                          <span class="value">
                            {{ product.GoodsValue }} {{ product.Currency }}
                          </span>
                        </div>
                        <div class="left2-item" v-if="product.CountryName">
                          <span class="label">
                            {{ $t.orderDetail.countryName }}
                          </span>
                          <span class="value">
                            {{ product.CountryName }}
                          </span>
                        </div>
                        <div class="left2-item" v-if="product.CargoCategory">
                          <span class="label">
                            {{ $t.orderDetail.cargoCategory }}
                          </span>
                          <span class="value">{{ product.CargoCategory }}</span>
                        </div>
                        <div class="left2-item">
                          <span class="label">
                            {{ $t.orderDetail.numberPackages }}
                          </span>
                          <span class="value">
                            {{ product.NumberPackages }}
                          </span>
                        </div>
                        <div class="left2-item">
                          <span class="label">
                            {{ $t.orderDetail.volume }}
                          </span>
                          <span class="value">{{ product.Volume }} cbm</span>
                        </div>
                        <div class="left2-item">
                          <span class="label">
                            {{ $t.orderDetail.weight }}
                          </span>
                          <span class="value">{{ product.Weight }} KG</span>
                        </div>
                        <div class="left2-item">
                          <span class="label">{{
                            $t.orderDetail.taxFeebearingParty
                          }}</span>
                          <span class="value" v-if="product.TaxFeebearingParty == 1">{{
                            $t.orderDetail.shipper
                          }}</span>
                          <span class="value" v-if="product.TaxFeebearingParty == 2">{{
                            $t.orderDetail.consignee
                          }}</span>
                        </div>
                      </div>
                      <div class="right2" v-if="product.ProductPictureList.length > 0">
                        <div class="images">
                          <van-image
                            width="80px"
                            height="80px"
                            fit="cover"
                            :src="imgUrlFilter(product.ProductPictureList[0])"
                            @click="imagePreview(product.ProductPictureList)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </van-collapse-item>
              </van-collapse>
            </template>
          </div>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.orderDetail.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.orderDetail.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="fpid.text"
          :label="$t.orderDetail.countryName"
          :placeholder="$t.orderDetail.select"
          @click="onShowFpid"
        />

        <van-field
          clickable
          readonly
          :value="fpdid.text"
          :label="$t.orderDetail.cargoCategory"
          :placeholder="$t.orderDetail.cargoSelect"
          @click="onShowFpdid"
        />
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.orderDetail.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.orderDetail.confirm
        }}</van-button>
      </div>
    </van-popup>

    <option-list
      event="showOrderDetailFreightPrice"
      :options="fpidList"
      @onSelect="onSelectFpid"
    ></option-list>

    <option-list
      event="showOrderDetailFreightPriceInfo"
      :options="fpdidList"
      @onSelect="onSelectFpdid"
    ></option-list>

    <van-dialog
      :title="$t.orderDetail.shippingAlertTitle"
      v-model="showShipping"
      @confirm="shippingConfirm"
      @cancel="showShipping = false"
      :confirm-button-text="$t.alert.confirmButtonText"
      :cancel-button-text="$t.alert.cancelButtonText"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="shipping-alert">
          <div class="shipping-alert-content1">
            <van-radio-group v-model="shippingForm.takeDeliveryType">
              <van-radio name="1">{{ $t.orderDetail.shippingType1 }}</van-radio>
              <van-radio name="2">{{ $t.orderDetail.shippingType2 }}</van-radio>
            </van-radio-group>
          </div>
          <div
            class="shipping-alert-content2"
            v-if="shippingForm.takeDeliveryType == '2'"
          >
            <van-button
              class="shipping-btn"
              size="small"
              type="primary"
              @click="actionAddressSelection"
              >{{ $t.orderDetail.selectAddress }}</van-button
            >
            <div class="shipping-txt" v-if="selectedAddress">
              <div>
                {{ $t.orderDetail.receivingName }}：
                {{ selectedAddress.ReceivingName }}
              </div>
              <div>
                {{ $t.orderDetail.phoneNumber }}：
                {{ selectedAddress.PhoneNumber }}
              </div>
              <div>
                {{ $t.orderDetail.receivingAddress }}：
                {{ selectedAddress.ReceivingAddress }}
              </div>
            </div>
          </div>
        </div>
      </slot>
    </van-dialog>
  </div>
</template>
<script>
import Selection from "@/views/main/shippingAddress-selection/index.js";
import OptionList from "@components/optionList/OptionList.vue";
import {
  Row,
  Col,
  Search,
  List,
  Image,
  Button,
  Popup,
  Form,
  Field,
  Tab,
  Tabs,
  Radio,
  RadioGroup,
  Collapse,
  CollapseItem,
} from "vant";

import Vue from "vue";
Vue.use(Row)
  .use(Col)
  .use(Search)
  .use(Image)
  .use(Button)
  .use(Popup)
  .use(Form)
  .use(Field)
  .use(Tab)
  .use(Tabs)
  .use(Radio)
  .use(RadioGroup)
  .use(Collapse)
  .use(CollapseItem);

export default {
  name: "orderDetail",
  components: {
    "van-list": List,
    OptionList,
  },
  data() {
    return {
      state: this.$route.query.state
        ? this.$route.query.state
        : parseInt(localStorage.getItem("MenuState")),
      stateList: [
        {
          title: this.$t.orderDetail.state1,
          name: 0,
          count: 0,
        },
        {
          title: this.$t.orderDetail.state2,
          name: 1,
          count: 0,
        },
        {
          title: this.$t.orderDetail.state3,
          name: 2,
          count: 0,
        },
        // {
        //   title: this.$t.orderDetail.state4,
        //   name: "3",
        //   count: 0,
        // },
        {
          title: this.$t.orderDetail.state5,
          name: 4,
          count: 0,
        },
        {
          title: this.$t.orderDetail.state6,
          name: 5,
          count: 0,
        },
        {
          title: this.$t.orderDetail.state7,
          name: 6,
          count: 0,
        },
      ],
      activeNames: [],
      page: 0,
      pageSize: 10,
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //筛选
      orderBy: "",
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.orderDetail.expressNumber,
          value: 1,
        },
        {
          text: this.$t.orderDetail.cargoName,
          value: 2,
        },
        {
          text: this.$t.orderDetail.cargoTrackingNumber,
          value: 3,
        },
      ],
      showFilter: false,
      fpid: { text: "", value: null },
      fpidList: [],
      fpdid: { text: "", value: null },
      fpdidList: [],
      //提货
      showShipping: false,
      shippingForm: {
        wbId: "",
        takeDeliveryType: "",
        crId: "",
      },
      selectedAddress: null,
      volumeIcon: require("@/assets/img/order/volume.png"),
      weightIcon: require("@/assets/img/order/weight.png"),
    };
  },
  watch: {
    state() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.tableData = [];
      this.getList(1);
    },
  },
  methods: {
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.orderDetail.inputText;
      }
    },
    onSearch() {
      this.initList();
      this.getList(1);
    },
    isFilter() {
      if (this.fpid.value || this.fpdid.value) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.fpid = { text: "", value: null };
      this.fpdid = { text: "", value: null };
      this.initList();
      this.getList(1);
    },
    filterSubmit() {
      this.initList();
      this.getList(1);
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      var pictureList = [];
      for (var image of images) {
        pictureList.push(this.imgUrlFilter(image));
      }
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: pictureList,
        startPosition: 0,
      });
    },
    firstLoad(page) {
      this.getList(page).then((success) => {
        if (success) {
          this.getFreightPriceListByPage();
        }
      });
    },
    stateChanged(state) {
      this.state = state;
      localStorage.setItem("MenuState", JSON.stringify(state));
      this.searchText = "";
      this.searchType = 1;
      if (this.state == "0") {
        this.searchTypeOptions = [
          {
            text: this.$t.orderDetail.expressNumber,
            value: 1,
          },
          {
            text: this.$t.orderDetail.cargoName,
            value: 2,
          },
        ];
      } else if (this.state == "1") {
        this.searchTypeOptions = [
          {
            text: this.$t.orderDetail.expressNumber,
            value: 1,
          },
          {
            text: this.$t.orderDetail.cargoName,
            value: 2,
          },
          {
            text: this.$t.orderDetail.cargoTrackingNumber,
            value: 3,
          },
        ];
      } else {
        this.searchTypeOptions = [
          {
            text: this.$t.orderDetail.expressNumber,
            value: 1,
          },
          {
            text: this.$t.orderDetail.cargoName,
            value: 2,
          },
          {
            text: this.$t.orderDetail.cargoTrackingNumber,
            value: 3,
          },
          {
            text: this.$t.orderDetail.sideWbNumber,
            value: 4,
          },
        ];
      }
    },
    getList(page) {
      return new Promise((resolve, reject) => {
        var param = {
          PageIndex: page,
          PageSize: this.pageSize,
          OrderState: this.state,
          FPId: this.fpid.value,
          FPDId: this.fpdid.value,
        };
        if (this.searchType == 1) {
          param.ExpressNumber = this.searchText;
        }
        if (this.searchType == 2) {
          param.CargoName = this.searchText;
        }
        if (this.searchType == 3) {
          param.CargoTrackingNumber = this.searchText;
        }
        if (this.searchType == 4) {
          param.WB_Number = this.searchText;
        }
        var request = null;
        if (this.state == 0) {
          request = this.$api.order.getCustomerOrderListByPage(param);
        } else if (this.state == 1) {
          request = this.$api.order.getCustomerOrderListByPage(param);
        } else {
          request = this.$api.order.getCustomerOrderHasShippedListByPage(param);
        }
        request
          .then((res) => {
            this.tableData = this.tableData.concat(res.data.Data);
            this.loading = false;
            this.error = false;
            this.errorText = "";

            this.page = res.meta.page;
            this.finished = this.page >= res.meta.lastPage;
            this.activeNames = [];
            this.customerOrderCountStatistics();
            resolve(true);
          })
          .catch((error) => {
            this.loading = false;
            this.error = true;
            this.errorText = error.message;
            reject();
          });
      });
    },
    onDelete(id) {
      this.$commonMethod.dialogConfirm(
        this.$t.orderDetail.confirmDelete,
        (_) => {
          this.deleteCustomerOrder(id);
        },
        (_) => {}
      );
    },
    deleteCustomerOrder(id) {
      this.$commonMethod.showLoading();
      let param = {
        COId: id,
      };
      this.$api.order
        .deleteCustomerOrder(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          const index = this.tableData.findIndex((order) => {
            return order.COId === id;
          });
          this.tableData.splice(index, 1);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoDetail(order) {
      var data = order;
      localStorage.setItem("goodsForecast", JSON.stringify(data));
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "goodsForecast",
        name: "goodsForecast",
        query: [
          {
            name: "pageType",
            value: "edit",
          },
        ],
      });
    },
    gotoPayBillList(e, id) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "paybillList",
        name: "paybillList",
        query: [
          {
            name: "wbNumber",
            value: id,
          },
        ],
      });
    },
    gotoCargoInquiry(e, id) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "cargoInquiry",
        name: "cargoInquiry",
        query: [
          {
            name: "wbNumber",
            value: id,
          },
        ],
      });
    },
    gotoException(e, id) {
      e.stopPropagation();
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "orderException",
        name: "orderException",
        query: [
          {
            name: "WB_Id",
            value: id,
          },
        ],
      });
    },
    onShowShipping(e, id) {
      e.stopPropagation();
      this.showShipping = true;
      this.shippingForm.wbId = id;
    },
    shippingConfirm() {
      if (
        this.shippingForm.takeDeliveryType == "1" ||
        this.shippingForm.takeDeliveryType == "2"
      ) {
        this.customerOrderChooseTakeDeliveryType().then((success) => {
          if (success) {
            this.showShipping = false;
          }
        });
      }
    },
    actionAddressSelection() {
      this.showShipping = false;
      const selection = Selection();
      selection.onSelected = (address) => {
        this.showShipping = true;
        this.shippingForm.crId = address.CRId;
        this.selectedAddress = address;
      };
      selection.show();
    },
    getAddress() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "shippingAddress",
        name: "shippingAddress",
        query: [],
      });
    },
    customerOrderChooseTakeDeliveryType() {
      this.$commonMethod.showLoading();
      var param = {
        WB_Id: this.shippingForm.wbId,
        TakeDeliveryType: this.shippingForm.takeDeliveryType,
        CRId: this.shippingForm.crId,
      };
      return new Promise((resolve) => {
        this.$api.order
          .customerOrderChooseTakeDeliveryType(param)
          .then((res) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
              titleMsg: res.message,
              type: "success",
            });
            this.getList(1);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    //111
    onShowFpid() {
      this.$bus.$emit("showOrderDetailFreightPrice", true);
    },
    onSelectFpid(item) {
      this.fpid.text = item.text;
      this.fpid.value = item.value;
      this.resetFpdid();
      this.loadFreightPriceInfo(item.value);
    },
    resetFpdid() {
      this.fpdid.text = "";
      this.fpdid.value = "";
    },
    customerOrderCountStatistics() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.order
          .customerOrderCountStatistics(param)
          .then((res) => {
            var data = res.data;
            for (var state of this.stateList) {
              if (state.name == "0") {
                state.count = data.PutInStorageCount;
              }
              if (state.name == "1") {
                state.count = data.HasPutInStorageCount;
              }
              if (state.name == "2") {
                state.count = data.InTransitCount;
              }
              if (state.name == "3") {
                state.count = data.ToBePickedUpCount;
              }
              if (state.name == "4") {
                state.count = data.ToBeDeliveredCount;
              }
            }
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getFreightPriceListByPage() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getFreightPriceListByPage(param)
          .then((res) => {
            this.formatFreightPrice(res.data.Data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPrice(items) {
      items.forEach((item) => {
        let data = {
          text: item.CountryName,
          image: item.NationalFlagPicture,
          value: item.FPId,
        };
        this.fpidList.push(data);
      });
    },
    //222
    onShowFpdid() {
      this.$bus.$emit("showOrderDetailFreightPriceInfo", true);
    },
    onSelectFpdid(item) {
      this.fpdid.text = item.text;
      this.fpdid.value = item.value;
    },
    loadFreightPriceInfo(id) {
      var param = {
        FPId: id,
      };
      return new Promise((resolve) => {
        this.$api.customerManagement
          .loadFreightPriceInfo(param)
          .then((res) => {
            var data = this.$commonMethod.deepClone(res.data.DetailList);
            this.formatFreightPriceInfo(data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatFreightPriceInfo(items) {
      var list = [];
      items.forEach((item) => {
        let data = {
          text: item.CargoCategory,
          value: item.FPDId,
        };
        list.push(data);
      });
      this.fpdidList = list;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.orderDetail {
  .van-tabs {
    ::v-deep .van-tabs__wrap {
      height: auto;
    }
    ::v-deep .van-tabs__nav {
      margin: 0;
      height: auto;
      border-left: none !important;
      border-right: none !important;
      border-color: #e4e9f0 !important;
      .van-tab--active {
        box-shadow: 0px 2.5px 6.5px 1px rgb(0 0 0 / 10%);
      }
      .van-tab {
        height: 38px;
        line-height: 38px;
        margin: 8px 0px 8px 8px;
        padding: 8px 16px;
        border: none;
        background: #f7f9fb;
        border-radius: 100px;
        border: 1px solid #e4e9f0 !important;
        .van-tab__text {
          font-size: 12px;
          font-weight: 500;
        }
      }
      .van-tab:last-child {
        margin: 8px !important;
      }
    }
  }
  .shipping-alert {
    padding: 0% 10%;
    line-height: 2;
    .shipping-alert-content1 {
      .van-radio-group {
        margin-top: 10%;
        .van-radio {
          margin-bottom: 10%;
        }
      }
    }
    .shipping-alert-content2 {
      text-align: left;
      margin-bottom: 10%;
      .shipping-btn {
        vertical-align: middle;
        border-radius: 5px;
        background: $-color-primary;
        border: none;
        .van-button__text {
          font-size: 14px !important;
        }
      }
      .shipping-txt {
        margin-top: 5%;
        font-size: 14px;
        color: #999;
      }
    }
  }
  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }
  .radio-label {
    color: #646566;
    margin-bottom: 10px;
    font-size: 14px;
  }
  .van-radio-group {
    margin-bottom: 20px;
  }
  .van-radio {
    margin-bottom: 10px;
    font-size: 14px;
    ::v-deep .van-radio__label {
      color: #646566;
    }
    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-color: #2750aa !important;
        border-color: #2750aa !important;
      }
    }
  }
  .van-form {
    width: 90%;
    margin: auto;
    .van-cell:after {
      border: none;
    }
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
  }
  .popup-footer {
    position: fixed;
    bottom: calc(0px + env(safe-area-inset-bottom));
    width: 100%;
    text-align: center;
    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }
    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }
  .van-pull-refresh {
    overflow: unset;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;
        .van-search__content {
          padding: 0px;
          margin-right: 10px;
          .van-cell {
            color: #969799;
            padding: 5px 8px 5px 8px;
          }
        }
        .custom-date {
          padding: 10px;
          .date-btn1 {
            width: 40%;
            display: inline-block;
            border-right: 1px solid #ebedf0;
            line-height: 33px;
            vertical-align: middle;
          }
          .date-btn2 {
            width: 40%;
            display: inline-block;
            line-height: 33px;
            vertical-align: middle;
          }
          .van-button {
            vertical-align: middle;
          }
        }
      }
      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;
        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }
  .list {
    padding: 0px 15px;
    .order {
      padding: 20px;
      margin-top: 15px;
      border-radius: 20px;
      background: white;
      border: 1px solid #e5e5e5;
      box-shadow: 0px 2.5px 5px 0px rgba(0, 0, 0, 0.1);
      font-size: 14px;
      .van-collapse:after {
        border: none;
      }
      .van-collapse {
        ::v-deep .van-collapse-item__content {
          padding: 0px;
        }
        .van-collapse-item {
          ::v-deep .van-cell--clickable:active {
            background-color: transparent !important;
          }
          ::v-deep .van-icon {
            color: #000;
            margin-left: 50%;
            margin-top: 20px;
          }
          ::v-deep .van-cell {
            padding: 0px;
            display: inline-block;
          }
          ::v-deep .van-cell:after {
            border: none;
          }
          ::v-deep .van-cell:before {
            border: none;
          }
        }
      }
      .expressNo {
        color: #1a347b;
        font-weight: bold;
        margin-bottom: 10px;
        vertical-align: middle;
        display: inline-block;
        width: 70%;
        .value {
          color: #000;
        }
      }
      .state1 {
        margin-bottom: 10px;
        vertical-align: middle;
        display: inline-block;
        width: 30%;
        text-align: right;
        font-weight: 500;
        .orange {
          color: orange;
          font-size: 12px;
        }
      }
      .left1 {
        vertical-align: middle;
        display: inline-block;
        width: 65%;
        .left1-item {
          color: #898da1;
          font-size: 12px;
          margin-bottom: 10px;
          .value {
            color: #000;
            font-family: monospace;
            .van-icon-success {
              color: #01aaa3;
              font-size: 15px;
              vertical-align: bottom;
            }
            .van-icon-cross {
              color: red;
              font-size: 15px;
              vertical-align: bottom;
            }
          }
        }
        .left1-item:last-child {
          margin-bottom: 0px !important;
        }
      }
      .right1 {
        vertical-align: middle;
        display: inline-block;
        width: 35%;
        .images {
          width: 80px;
          height: 80px;
          border-radius: 100px;
          overflow: hidden;
          vertical-align: middle;
          margin: 10px auto;
        }
      }
      .left2 {
        background: #f7f9fb;
        padding: 5px 10px 0px 10px;
        border-radius: 10px;
        .left2-item {
          padding-bottom: 5px;
          .label {
            color: #898da1;
            font-size: 12px;
            width: 50%;
            vertical-align: middle;
            display: inline-block;
          }
          .value {
            color: #000;
            font-size: 12px;
            font-family: monospace;
            width: 50%;
            vertical-align: middle;
            display: inline-block;
            text-align: right;
          }
        }
      }
      .right2 {
        .images {
          width: 80px;
          height: 80px;
          border-radius: 100px;
          overflow: hidden;
          vertical-align: middle;
          margin: 10px auto;
        }
      }
      .packages {
        background: #f7f9fb;
        font-size: 12px;
        margin-top: 10px;
        padding: 10px 10px 0px 10px;
        border-radius: 10px;
        .packages-item {
          padding-bottom: 10px;
          .packages-item-label {
            color: #898da1;
            font-size: 12px;
            width: 50%;
            vertical-align: middle;
            display: inline-block;
          }
          .packages-item-value {
            color: #000;
            font-size: 12px;
            font-weight: 500;
            width: 50%;
            text-align: right;
            font-family: monospace;
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
      .header {
        vertical-align: middle;
        display: inline-block;
        width: 100%;
        // margin-bottom: 10px;
        border-bottom: 1px solid #e5e5e5;
        .wbNumber {
          color: #1a347b;
          font-weight: bold;
          margin-bottom: 10px;
          vertical-align: middle;
          display: inline-block;
          width: 70%;
          .value {
            color: #000;
          }
        }
        .state2 {
          margin-bottom: 10px;
          vertical-align: middle;
          display: inline-block;
          width: 30%;
          text-align: right;
          font-weight: bold;
          .red {
            color: #ff454c;
          }
          .blue {
            color: #028ef3;
          }
          .green {
            color: #00ae61;
          }
        }
        .all-packages {
          .all-packages-item {
            display: inline-block;
            width: 50%;
            margin-bottom: 10px;
            .van-image {
              vertical-align: middle;
              display: inline-block;
              margin-right: 5px;
              margin-bottom: 2px;
            }
            .all-packages-label {
              color: #898da1;
              font-size: 12px;
              vertical-align: middle;
              display: inline-block;
              margin-right: 5px;
            }
            .all-packages-value {
              color: #000;
              font-size: 12px;
              font-weight: 500;
              font-family: monospace;
              vertical-align: middle;
              display: inline-block;
            }
          }
        }
      }
      .content {
        vertical-align: middle;
        display: inline-block;
        width: 100%;
        .product {
          margin-bottom: 10px;
        }
        .product:last-child {
          margin-bottom: 0px !important;
        }
      }
      .buttons {
        text-align: right;
        .van-button:first-child {
          margin-left: 0% !important;
        }
        .van-button {
          border: none;
          margin-top: 10px;
          margin-left: 3%;
          border-radius: 10px;
          height: 35px;
          line-height: 35px;
          width: 48.5%;
        }
        .primary-btn {
          background: #1a347b;
          .van-button__text {
            font-size: 12px !important;
          }
        }
        .default-btn {
          background: #f7f9fb;
          color: #333;
          font-weight: 500;
          border: 1px solid #e4e9f0;
          .van-button__text {
            font-size: 12px !important;
          }
        }
        .danger-btn {
          background: $-color-red;
          .van-button__text {
            font-size: 12px !important;
          }
        }
      }
    }
  }
}
</style>
